import type { NodeChange, EdgeChange } from '@xyflow/react'

export function withChangeLogger<T extends NodeChange | EdgeChange>(label: string, handler: (changes: T[]) => void) {
  return (changes: T[]) => {
    // eslint-disable-next-line no-console
    console.groupCollapsed(`[RF] ${label}`)
    // eslint-disable-next-line no-console
    console.table(changes)
    // eslint-disable-next-line no-console
    console.groupEnd()
    handler(changes)
  }
}

export default function ChangeLogger() {
  return null
}
